import React, { } from 'react';

import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";

import { IconAlertTriangle, IconX } from '@tabler/icons-react';

import LocalStorageHelper from "../../Utilities/Helpers/LocalStorageHelper";

import { ColorEnum } from '../../Utilities/Enums/ColorEnums';
import { WarningType, WarningTypeText } from '../../Utilities/Enums/NoticeEnums';

import CustomIconButton from './CustomIconButton';

type CustomNoticeSnackbarInterface = {
    // colorType?: ColorEnum;
    warningType?: WarningType,
    label?: string;
    onRemove?: any;
};

type NoticeColorTypes = { [K in ColorEnum]: {
    backgroundColor: string,
    darkbackgroundColor: string,
    textColor: string,
    darktextColor: string,
    borderColor: string,
    darkborderColor: string,
} };

const NoticeColors: NoticeColorTypes = {
    [ColorEnum.RED]: {
        backgroundColor: "#fde8e4 !important",
        darkbackgroundColor: "#400e05 !important",
        textColor: "#d1664f !important",
        darktextColor: "#d1664f !important",
        borderColor: "#f06548 !important",
        darkborderColor: "#95240c !important",
    },
    [ColorEnum.YELLOW]: {
        backgroundColor: "#fff5da !important",
        darkbackgroundColor: "#372800 !important",
        textColor: "#d9a009 !important",
        darktextColor: "#f7c236 !important",
        borderColor: "#ffbc0a !important",
        darkborderColor: "#b08000 !important",
    },
    [ColorEnum.GREEN]: {
        backgroundColor: "#fde8e4 !important",
        darkbackgroundColor: "#400e05 !important",
        textColor: "#d1664f !important",
        darktextColor: "#f7c236 !important",
        borderColor: "#f06548 !important",
        darkborderColor: "#95240c !important",
    },
    [ColorEnum.BLUE]: {
        backgroundColor: "#fde8e4 !important",
        darkbackgroundColor: "#400e05 !important",
        textColor: "#d1664f !important",
        darktextColor: "#f7c236 !important",
        borderColor: "#f06548 !important",
        darkborderColor: "#95240c !important",
    },
    [ColorEnum.GRAY]: {
        backgroundColor: "#fde8e4 !important",
        darkbackgroundColor: "#400e05 !important",
        textColor: "#d1664f !important",
        darktextColor: "#f7c236 !important",
        borderColor: "#f06548 !important",
        darkborderColor: "#95240c !important",
    },
}

const CustomSnackBarContainer = styled(Card) <{ $colorType: ColorEnum; $darkMode?: boolean; }>`
    border: 1px solid;
    border-left: 4px solid;
    background: ${(props) => (props.$darkMode ? NoticeColors[props.$colorType].darkbackgroundColor : NoticeColors[props.$colorType].backgroundColor)};
    border-color: ${(props) => (props.$darkMode ? NoticeColors[props.$colorType].darkborderColor : NoticeColors[props.$colorType].borderColor)};
    border-radius: 4px !important;
    // box-shadow: none !important;
    padding: 0px 20px;
    height: 55px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .noticeContainer {
        display: flex;
        align-items: center;

        svg {
            width: 20px;
            height: 20px;
            margin: 0px 5px 0px 0px;
            color: ${(props) => (props.$darkMode ? NoticeColors[props.$colorType].darktextColor : NoticeColors[props.$colorType].textColor)};
        }

        .noticeHeader {
            text-transform: uppercase;
            font-size: 0.825rem;
            font-weight: 600;
            color: ${(props) => (props.$darkMode ? NoticeColors[props.$colorType].darktextColor : NoticeColors[props.$colorType].textColor)};
        }

        .noticeValue {
            font-size: 0.825rem;
            font-weight: 600;
            color: ${(props) => (props.$darkMode ? NoticeColors[props.$colorType].darktextColor : NoticeColors[props.$colorType].textColor)};
            margin: 0px 0px 0px 5px;
        }
    }

    .closeBtn {
        width: 20px;
        height: 20px;
        padding: 2px;

        svg {
            padding: 0px;
            margin: 0px;
            color: ${(props) => (props.$darkMode ? NoticeColors[props.$colorType].darktextColor : NoticeColors[props.$colorType].textColor)};
        }
    }
`;

const CustomNoticeSnackbar = (fieldProps: CustomNoticeSnackbarInterface) => {
    let isDarkMode = LocalStorageHelper.isDarkMode();
    let _warningType: any = WarningTypeText[fieldProps?.warningType ?? 1];
    
    if (!fieldProps?.label) {
        return <></>
    }

    return <CustomSnackBarContainer $colorType={_warningType?.color ?? 0} $darkMode={isDarkMode}>
        <div className="noticeContainer">
            <IconAlertTriangle />
            <Typography className="noticeHeader">{_warningType?.title ?? "--"}:</Typography>
            <Typography className="noticeValue">{fieldProps?.label ?? ""}</Typography>
        </div>

        <CustomIconButton className="closeBtn" toolTipName='Close'
            icon={<IconX />}
            onClick={() => {
                if(fieldProps?.onRemove) {
                    fieldProps.onRemove();
                }
            }} />
    </CustomSnackBarContainer>
}

export default CustomNoticeSnackbar;